import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox" ]

  toggleDiscountTypeSection() {
    const radios = document.getElementsByName('combo_discount_setting[discount_type]');
    let selectedValue
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })

    const discountRateSection = document.querySelector("#discount_rate_section");
    const totalPriceSection = document.querySelector("#total_price_section");

    if (selectedValue == "total_price") {
      totalPriceSection.classList.remove("d-none")
      discountRateSection.classList.add("d-none")
      this.clearDiscountRateDetails();
    } else {
      totalPriceSection.classList.add("d-none")
      discountRateSection.classList.remove("d-none")
      this.clearTotalPriceDetails();
    }
  }

  // 清除組合價設定區的多餘輸入框
  clearTotalPriceDetails() {
    const totalPriceDetails = document.querySelectorAll(".total_price_detail");
    totalPriceDetails.forEach((detail, index) => {
        if (index !== 0) {
            detail.remove();
        } else {
            // 將所有input清空
            detail.querySelectorAll("input").forEach(input => {
                input.value = '';
            });
        }
    });
  }

  // 清除定價折扣設定區的多餘輸入框
  clearDiscountRateDetails() {
    const discountRateDetails = document.querySelectorAll(".discount_rate_detail");
    discountRateDetails.forEach((detail, index) => {
        if (index !== 0) {
            detail.remove();
        } else {
            // 將所有input清空
            detail.querySelectorAll("input").forEach(input => {
                input.value = '';
            });
        }
    });
  }

  addDetail(selector, containerSelector) {
    const currentDetails = document.querySelectorAll(selector);

    // 如果當前的數量已達到3，則不進行複製和添加
    if (currentDetails.length < 3) {
      const detail = document.querySelector(selector);
      const clonedDetail = detail.cloneNode(true);
      clonedDetail.querySelectorAll("input").forEach(input => {
        input.value = ''; });
      const container = document.querySelector(containerSelector);
      container.appendChild(clonedDetail);
    }
  }

  addDiscountRateDetail(event) {
    this.addDetail(".discount_rate_detail", "#discount_rate_detail_container");
  }

  addTotalPriceDetail(event) {
    this.addDetail(".total_price_detail", "#total_price_detail_container");
  }

  removeDetail(event, containerId, detailClass) {
    const container = document.getElementById(containerId);
    const details = container.getElementsByClassName(detailClass);

    // 如果只有一組 detail，則清空所有的 input 欄位
    if (details.length === 1) {
      const inputs = details[0].getElementsByTagName("input");
      Array.from(inputs).forEach((input) => (input.value = ""));
    }
    // 如果有多組 detail，則移除當前的 detail
    else {
      event.target.closest("." + detailClass).remove();
    }
  }
  removeTotalPriceDetail(event){
    this.removeDetail(event, "total_price_detail_container", "total_price_detail");
  }

  removeDiscountRateDetail(event) {
    this.removeDetail(event, "discount_rate_detail_container", "discount_rate_detail");
  }
}
